document.addEventListener("DOMContentLoaded", () => {
	const mapListToggle = document.getElementById("toggle-map-list-view");
	if (!mapListToggle) {
		return;
	}

	// add 'active' class to list element by default on page load
	document.querySelector<HTMLElement>(".plauditQueryLoop--map .plauditQueryLoop__main")?.classList.toggle('active', true);

	mapListToggle.addEventListener('click', () => {
		const innerBtn = mapListToggle.querySelectorAll<HTMLElement>(".wp-element-button");

		const mapView = document.querySelector<HTMLElement>(".plauditQueryLoop--map .plauditQueryLoop__header");
		const listView = document.querySelector<HTMLElement>(".plauditQueryLoop--map .plauditQueryLoop__main");
		if (!mapView || !listView) {
			return;
		}

		if (mapView.classList.contains('active')) {
			mapView.classList.remove('active');
			listView.classList.toggle('active', true);
			mapListToggle.setAttribute('data-icon', 'map');
			for (const innerBtnElement of innerBtn) {
				innerBtnElement.innerText = "Map View";
			}
		} else {
			mapView.classList.toggle('active', true);
			listView.classList.remove('active');
			mapListToggle.setAttribute('data-icon', 'list');
			for (const innerBtnElement of innerBtn) {
				innerBtnElement.innerText = "List View";
			}
		}
	});
});
